import { storeToRefs } from 'pinia';
import { useBillingStore } from '@/stores/billing-store';

export const useInvoices = () => {
  const getInvoicesList = async (page: number) => {
    const { isLoading, invoicesInPage } = storeToRefs(useBillingStore());
    const { getInvoices } = useBillingStore();
    try {
      isLoading.value = true;

      const data = await getInvoices(page);

      if (data) {
        const newRentals = JSON.parse(JSON.stringify(data));

        if (page === 1) {
          invoicesInPage.value = [];
        }
        invoicesInPage.value = invoicesInPage.value.concat(newRentals);
      }
    } catch (error) {
      console.error('error', error);
    } finally {
      isLoading.value = false;
    }
  };

  return { getInvoicesList };
};
